<div class="payment-detailed-container" fxLayout="column">
  <mat-toolbar
    class="header"
    fxLayout="row"
    fxLayoutAlign="space-between center"
  >
    <div class="title-return" fxLayout="row" fxLayoutAlign="center center">
      <button mat-button routerLink="..">
        <jam-icon name="chevron-right" vertical-align="middle"></jam-icon>
        برگشت
      </button>
      <span class="title">جزئیات سفارش</span>
    </div>

    <button mat-button color="warn">
      فاکتور خرید
      <jam-icon name="document-f" vertical-align="middle"></jam-icon>
    </button>
  </mat-toolbar>

  <div class="meta-data" fxLayout="row" fxLayoutAlign="space-between center">
    <div class="info code">کد سفارش :{{ payment.factorNumber }}</div>
    <div class="info date">
      تاریخ ثبت سفارش: {{ toJalaliDate(payment.createdAt) }}
    </div>
    <div class="info status mat-elevation-z2">
      وضعیت:
      {{ persianStatus }}
    </div>
  </div>

  <div
    class="transport-information"
    fxLayout="row wrap"
    fxFlex="50"
    fxLayoutAlign="space-between center"
  >
    <div class="info recipientName">
      تحویل گیرنده : {{ payment.address!.recipientName }}
    </div>

    <div class="info recipientName">
      مبایل : {{ payment.address?.phoneNumber }}
    </div>

    <div class="info recipientName">آدرس : {{ payment.address?.address }}</div>
    <div class="info recipientName">
      مبلغ :
      {{ payment.amount?.toString() || "" | irc : "T" | digitsEnToFa }}
    </div>
  </div>

  <div
    class="errors"
    *ngIf="payment?.errors?.length && payment.errors?.length! > 0"
  >
    <ul>
      <li class="error" *ngFor="let error of payment.errors">
        <span>
          <strong class="type" [ngSwitch]="error.type">
            <span *ngSwitchCase="'FILE_BROKEN'">مشکل فایل</span>
            <span *ngSwitchCase="'INFORMATION_FALSY'">مشکل اطلاعات</span>
            <span *ngSwitchCase="'NOT_PROCESSABLE'">غیر قابل انجام</span>
          </strong>
          -
          <span class="body">
            {{ error.message }}
          </span>
        </span>
      </li>
    </ul>
  </div>

  <div class="orders-container">
    <div class="transportation-method">
      <div class="type">
        <jam-icon
          class="icon"
          color="primary"
          [name]="payment.transportationMethod?.icon || 'car'"
        ></jam-icon>
        <span>{{ payment.transportationMethod?.name }}</span>
      </div>
      <span
        >هزینه ارسال :
        {{
          payment.transportationMethod?.valueAdded?.toString() || "" | irc : "T"
        }}</span
      >
    </div>
    <shared-order
      [orderObject]="order"
      [actionsOn]="false"
      *ngFor="let order of payment.orders; index as i"
    ></shared-order>
  </div>
</div>
